import { mapGetters, mapActions } from 'vuex';
import { isBefore } from 'date-fns';

import addUTCTimeZoneDesignator from '@/utils/add-utc-time-zone-designator';

const sortByRecent = (appointmentIds, entities) => {
  const sorted = appointmentIds
    .map(appointmentId => entities[appointmentId] && appointmentId)
    .filter(Boolean)
    .sort(
      (first, second) =>
        new Date(entities[first].start_dtm) - new Date(entities[second].start_dtm)
    );

  const past = [];
  const upcoming = [];

  sorted.forEach((appointmentId) => {
    if (
      isBefore(
        new Date(addUTCTimeZoneDesignator(new Date(entities[appointmentId].end_dtm))),
        Date.now()
      )
    ) {
      past.push(appointmentId);
    } else {
      upcoming.push(appointmentId);
    }
  });

  return [...upcoming, ...past];
};

export default {
  computed: {
    ...mapGetters('entities', {
      appointmentEntities: 'appointments',
    }),
    ...mapGetters('dashboard/job', [
      'currentJobAppointmentsMeta',
      'currentRawJobAppointments',
      'currentSortedRawJobAppointments',
      'sortedByUpcomingDateJobAppointments',
    ]),
    appointment () {
      const appointment = this.appointmentEntities[this.appointmentId];
      return (
        appointment && {
          ...appointment,
          start_dtm: addUTCTimeZoneDesignator(appointment.start_dtm),
          end_dtm: addUTCTimeZoneDesignator(appointment.end_dtm),
        }
      );
    },
    appointments () {
      return (this.appointmentIds
        ? sortByRecent(this.appointmentIds, this.appointmentEntities)
        : this.sortedByUpcomingDateJobAppointments
      )
        .map(
          appointmentId =>
            this.appointmentEntities[appointmentId] && {
              ...this.appointmentEntities[appointmentId],
              start_dtm: addUTCTimeZoneDesignator(
                this.appointmentEntities[appointmentId].start_dtm
              ),
              end_dtm: addUTCTimeZoneDesignator(
                this.appointmentEntities[appointmentId].end_dtm
              ),
            }
        )
        .filter(Boolean);
    },
  },
  methods: {
    // To be remove
    ...mapActions('dashboard/job', [
      'fetchAppointments',
      'createOrUpdateAppointments',
      'deleteAppointments',
      'exportAppointments',
    ]),
  },
};
